import HeaderSection from "../components/Header";
import { Outlet } from "react-router";

export default function VacancyPage() {
  return (
    <div className="bg-[#9cbc66] text-custom-foreground-white">
      <HeaderSection />

      <div className="px-10 pb-16 pt-32 flex flex-col gap-8 max-w-5xl mx-auto">
        <h1 className="text-4xl font-bold">Vacature: Operations Manager</h1>
        <p>
          <strong>Keuleers & Co</strong>{" "}
          (<a href="https://www.keuleers.be" target="_blank" rel="noreferrer" className="underline">
            www.keuleers.be
          </a>{" "}
          - Bonheiden / Mechelen) is een groeiende familiale organisatie met meesterschap in hout.
          De organisatie produceert op maat verpakkingsoplossingen voor de industrie en verhandelt hout naar vakman & hobbyist.
        </p>

        <div className="bg-white text-[#023530] p-8 rounded shadow">
          <h2 className="text-2xl font-semibold mb-4">
            Operationsmanager met visie – Bouw mee aan de toekomst van onze productieplant
          </h2>
          <p className="mb-4">
            Ben jij klaar om het verschil te maken op de werkvloer én in de toekomst van een groeiende familiale KMO?
            Als operationsmanager ben jij de drijvende kracht achter een productieomgeving die klaar is voor morgen.
          </p>

          <h3 className="font-semibold text-xl mt-6 mb-2">Jouw impact</h3>
          <ul className="list-disc ml-6 space-y-1">
            <li>Je leidt, motiveert en coacht je team, en bent een aanspreekpunt bij uitstek.</li>
            <li>Je bewaakt de planning, volgt de voorraad en processen op, en grijpt proactief in waar nodig.</li>
            <li>Je controleert of producten en grondstoffen voldoen aan de kwaliteitsnormen.</li>
            <li>Je denkt mee met de bedrijfsleiders over strategische doelen.</li>
            <li>Je streeft voortdurend naar verbetering.</li>
          </ul>

          <h3 className="font-semibold text-xl mt-6 mb-2">Wat jij meebrengt</h3>
          <ul className="list-disc ml-6 space-y-1">
            <li>Natuurlijke leider met empathie en een verbindende stijl.</li>
            <li>Bachelor of ingenieur, met goede kennis van Engels en Frans.</li>
            <li>Ondernemend, communicatief en oplossingsgericht.</li>
            <li>Je voelt je thuis op de werkvloer én denkt toekomstgericht.</li>
            <li>Scherp oog voor kwaliteit en klantgerichtheid.</li>
          </ul>

          <h3 className="font-semibold text-xl mt-6 mb-2">Wat wij bieden</h3>
          <ul className="list-disc ml-6 space-y-1">
            <li>Een betekenisvolle rol waarin jij de koers mee bepaalt.</li>
            <li>Authentieke werkomgeving met directe lijnen naar het management.</li>
            <li>Ruimte voor initiatief, persoonlijke groei en impact.</li>
            <li>Marktconform salarispakket in een stabiele, ambitieuze organisatie.</li>
          </ul>

          <div className="mt-8 bg-[#e0f2f1] text-[#004d40] p-4 rounded border-l-4 border-[#00796b]">
            <p className="mb-1">
              <strong>Interesse of vragen?</strong> Deze vacature wordt exclusief begeleid door Sodeva Consulting & Development.
            </p>
            <p className="mb-1">Zemstbaan 22 / 24, 2800 Mechelen</p>
            <p className="mb-1">
              <strong>Solliciteren?</strong> Mail je CV naar{" "}
              <a href="mailto:rdb@sodevaconsulting.com" className="underline">
                rdb@sodevaconsulting.com
              </a>
            </p>
            <p>
              <strong>Vragen?</strong> Bel naar{" "}
              <a href="tel:+3215421655" className="underline">
                +32 15 42 16 55
              </a>
            </p>
          </div>
        </div>
      </div>
      <Outlet />
    </div>
  );
}
